import { useState, useEffect, useCallback } from 'react';
import { getStock } from '../utils/api';

export const useStock = (pollInterval = 3000) => {
  const [stock, setStock] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [lastUpdated, setLastUpdated] = useState(null);

  const fetchStock = useCallback(async () => {
    try {
      const data = await getStock();
      setStock(data);
      setLastUpdated(new Date());
      setError(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchStock();
    const interval = setInterval(fetchStock, pollInterval);
    return () => clearInterval(interval);
  }, [fetchStock, pollInterval]);

  return { stock, loading, error, lastUpdated, refetch: fetchStock };
};
